import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminCopyListIcon = (props: IconProps) => (
  <Icon width="17px" height="16px" viewBox="0 0 17 16" {...props}>
    <path d="M10.7069 0.666992H2.70687C1.97354 0.666992 1.37354 1.26699 1.37354 2.00033V11.3337H2.70687V2.00033H10.7069V0.666992ZM12.7069 3.33366H5.37354C4.6402 3.33366 4.0402 3.93366 4.0402 4.66699V14.0003C4.0402 14.7337 4.6402 15.3337 5.37354 15.3337H12.7069C13.4402 15.3337 14.0402 14.7337 14.0402 14.0003V4.66699C14.0402 3.93366 13.4402 3.33366 12.7069 3.33366ZM12.7069 14.0003H5.37354V4.66699H12.7069V14.0003Z" />
  </Icon>
);

export default memo(AdminCopyListIcon);
